import React from 'react';
export const Head = ({ eyebrow, title, text, light }) => (
  <div className="text-center mb-5">
    <div className={`eyebrow mb-2 ${light ? "light" : ""}`}>{eyebrow}</div>
    <h2 className={`h-lg mb-2 ${title === "Recognition Should Be Earned" ? "text-white" : ""}`}>{title}</h2>
    {text && <p className="p-md mx-auto mb-0" style={{ maxWidth: 640 }}>{text}</p>}
  </div>
);

export const Ring = ({ value }) => {
  const r = 52, c = 2 * Math.PI * r;
  return (
    <svg width="140" height="140" viewBox="0 0 140 140">
      <circle cx="70" cy="70" r={r} fill="none" stroke="#e5ecff" strokeWidth="12" />
      <circle cx="70" cy="70" r={r} fill="none" stroke="#1d4ed8" strokeWidth="12" strokeLinecap="round"
        strokeDasharray={c} strokeDashoffset={c * (1 - value / 100)} transform="rotate(-90 70 70)" />
      <text x="70" y="76" textAnchor="middle" className="ring-text">{value}</text>
      <text x="70" y="94" textAnchor="middle" fontSize="9" fill="#64748b">SCORE / 100</text>
    </svg>
  );
};

export function CleanContent({ children }) {
  const cleanText = (text) =>
    text
      .replace(/(\d)\.(\d)/g, '$1@@DECIMAL@@$2')
      .replace(/\./g, '')
      .replace(/-/g, ' ')
      .replace(/@@DECIMAL@@/g, '.')
      .replace(/\s{2,}/g, ' ');

  const cleanTextProps = (props) => {
    const cleanedProps = { ...props };

    ['alt', 'aria-label', 'eyebrow', 'placeholder', 'text', 'title'].forEach(
      (key) => {
        if (typeof cleanedProps[key] === 'string') {
          cleanedProps[key] = cleanText(cleanedProps[key]);
        }
      }
    );

    if ('children' in cleanedProps) {
      cleanedProps.children = cleanChildren(cleanedProps.children);
    }

    return cleanedProps;
  };

  const cleanChildren = (content) =>
    React.Children.map(content, (child) => {
      if (typeof child === 'string') return cleanText(child);
      if (!React.isValidElement(child)) return child;
      return React.cloneElement(child, cleanTextProps(child.props));
    });

  return <>{cleanChildren(children)}</>;
}
